module.exports = __webpack_public_path__ + "static/media/magnifying-glass-solid.2b55c2cc.png";